var exports = {
  "Zp": "xe533113f--eb3830--layout",
  "DD": "xe533113f--eb3830--title",
  "VA": "xe533113f--eb3830--subtitle",
  "E1": "xe533113f--eb3830--scrollable",
  "ML": "xe533113f--eb3830--rooms-filter",
  "fx": "xe533113f--eb3830--period-filter",
};

module.exports = exports;
